<template>
  <div class="news-list">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getNewsList"
    >
      <div
        class="item"
        v-for="(item, index) in newsList"
        :key="index"
        @click="goDetail(index)"
      >
        <h2 v-if="item.newsType == 'yjyggyj'">
          {{
            item.factor.indexnameG
              ? item.factor.indexnameG
              : item.factor.indexname
          }}
        </h2>
        <h2 v-else class="w100">{{ item.title }}</h2>
        <template v-if="item.newsType == 'yjyggyj'">
          <div class="tag">
            <p v-if="item.latestNfreq == undefined">
              变动幅度{{ item.latestValue }}%
            </p>
            <p v-else>
              连续{{ item.latestNfreq }}期累计变动值{{ item.latestValue }}%
            </p>
            <div class="star" @click.stop="showStarTip(index, $event)">
              <template v-if="item.star != undefined">
                <span
                  v-for="(star, index2) in 3"
                  :key="index2"
                  :class="{
                    active: index2 < Math.abs(item.star),
                    yellow: item.star < 0,
                  }"
                ></span>
              </template>
            </div>
          </div>
          <div class="info">
            {{ item.freqName }}频
            <i>·</i>
            <em>{{ item.swiL3Name }}</em>
            <i>·</i>
            {{ item.reportTime }}
          </div>
        </template>
        <template v-else>
          <div class="tag">
            <p>
              {{ item.source }}
              <i>·</i>
              {{ item.otime.slice(0, 10) }}
            </p>
            <div class="star" @click.stop="showStarTip(index, $event)">
              <template v-if="item.star != undefined">
                <span
                  v-for="(star, index2) in 3"
                  :key="index2"
                  :class="{
                    active: index2 < Math.abs(item.star),
                    yellow: item.star < 0,
                  }"
                ></span>
              </template>
            </div>
          </div>
        </template>
        <div class="chart-line" v-if="item.newsType == 'yjyggyj'">
          <ChartLine
            :index="index"
            :factorId="item.factorId"
            :star="item.star"
          />
        </div>
      </div>
    </van-list>

    <template v-if="newsList.length > 0">
      <p class="star-tip" v-show="isStarTip">
        {{ this.newsList[this.newsIndex].star > 0 ? "正面" : "负面" }}:
        {{ starLv[Math.abs(this.newsList[this.newsIndex].star) - 1] }}星
      </p>
    </template>
  </div>
</template>

<script>
  import ChartLine from "./ChartLine.vue";
  export default {
    components: {
      ChartLine,
    },
    props: ["jhyjParam", "handleDataLoadedNum"],
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        navList: [
          {
            name: "机会预警",
            value: "qlyj-yjyggyj",
          },
          {
            name: "负面舆情",
            value: "qlyj-fmyq",
          },
        ],
        newsIndex: 0,
        pageNum: 1,
        newsList: [], // 资讯列表
        isNewsResult: false, //资讯无数据
        isStarTip: false,
        starLv: ["一", "二", "三"], // 星星等级
        isMore: true, // 滚动加载
        chartDate: [], // 折线时间
        chartData: [], // 折线数
        navTop: 0,
        themeStyleVs: "",
        emptyMsg: "加载中",
      };
    },
    mounted() {
      this.token = this.$route.query.token;
      this.themeStyleVs = this.$route.query.themeStyleVs;
    },
    watch: {
      jhyjParam: {
        handler() {
          this.newsList = [];
          this.newsIndex = 0;
          this.isStarTip = false;
          this.isNewsResult = false;
          this.pageNum = 1;
          this.getNewsList();
        },
        deep: true,
      },
    },
    methods: {
      // 获取资讯列表
      getNewsList() {
        let _this = this;
        _this.isMore = false;
        _this.emptyMsg = "加载中";
        var postParam = {
          qid: new Date().getTime(),
          pageNum: _this.pageNum,
          param: _this.jhyjParam,
        };
        _this
          .$http({
            method: "post",
            url:
              window.config.research_server +
              "/research-framework-server/rf/news/page",
            data: postParam,
            headers: {
              token: _this.token,
            },
          })
          .then((res) => {
            // 加载状态结束
            _this.loading = false;
            if (res.data.code == 0) {
              _this.newsList.push(...res.data.data.data);
              // 数据全部加载完成
              if (res.data.data.data.length < 20) {
                _this.finished = true;
              } else {
                _this.pageNum += 1;
              }
            } else {
              _this.finished = true;
            }

            if (
              _this.handleDataLoadedNum == 1 ||
              _this.handleDataLoadedNum == 5
            ) {
              _this.$emit("data-loaded"); // 发出事件通知父组件数据已经加载完毕
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      // 显示星星等级
      showStarTip(i, e) {
        var offsetTop = e.currentTarget.offsetTop;
        var offsetTopParent =
          e.currentTarget.parentElement.parentElement.offsetTop;
        var offsetLeft = e.currentTarget.offsetLeft;
        var left = 0;
        this.newsIndex = i;
        this.isStarTip = true;
        document.querySelector(".star-tip").style.top =
          offsetTop + offsetTopParent - 28 + "px";
        if (this.newsList[i].newsType === "yjyggyj") {
          left = 12;
        }
        document.querySelector(".star-tip").style.left =
          offsetLeft - left + "px";
      },
      goDetail(i) {
        var url = "";
        if (this.jhyjParam.category === "qlyj-fmyq") {
          if (
            this.$store.state.fmyqVisited.indexOf(this.newsList[i].id) == -1
          ) {
            this.$store.commit("getfmyqVisited", this.newsList[i].id);
          }
          // this.$router.push({path: '/fmyqDetail', query:{esId: this.newsList[i].esId,DZHSPECIAL: 281}})
          url = "fmyqDetail?DZHSPECIAL=281&esId=" + this.newsList[i].esId;
          this.toUrl(url);
        } else {
          if (
            this.$store.state.jhyjVisited.indexOf(this.newsList[i].id) == -1
          ) {
            this.$store.commit("getjhyjVisited", this.newsList[i].id);
          }

          var indexname =
            this.newsList[i].newsType == "yjyggyj"
              ? this.newsList[i].factor.indexnameG
                ? this.newsList[i].factor.indexnameG
                : this.newsList[i].factor.indexname
              : this.newsList[i].title;
          url = `jhyjDetail?DZHSPECIAL=281&level3Code=${
            this.newsList[i].swiL3Code
          }&indexId=${this.newsList[i].factorId}&date=${
            this.newsList[i].reportTime
          }&freq=${this.newsList[i].freq}&indexName=${encodeURIComponent(
            indexname
          )}`;
          this.toUrl(url);
        }
      },
      getVisited(i) {
        var flagVisit =
          this.jhyjParam.category == "qlyj-fmyq"
            ? this.$store.state.fmyqVisited.includes(this.newsList[i].id)
            : this.$store.state.jhyjVisited.includes(this.newsList[i].id);
        var flagBlur = !this.isVip && i > 0 ? true : false;
        return {
          visited: flagVisit,
          blur: flagBlur,
        };
      },
    },
    beforeDestroy() {
      window.onscroll = () => {};
    },
  };
</script>

<style lang="scss" scoped>
  .news-list {
    padding: 0 0.16rem;
    height: calc(100vh - 1.27rem);
    overflow-y: auto;
    .item {
      position: relative;
      padding: 0.12rem 0;
      &.blur {
        filter: blur(9px);
      }
      &.visited {
        h2 {
          color: #999;
        }
      }
      &:before {
        @include border(top, #f8f8f8);
      }
      &:first-child {
        &::before {
          display: none;
        }
      }
      h2 {
        font-size: 0.16rem;
        color: #222;
        @include line-clamp(2);
        width: 74%;
        // height: 0.44rem;
        line-height: 0.22rem;
        &.w100 {
          width: 100%;
        }
      }
      .tag {
        font-size: 0.12rem;
        color: #999;
        margin: 0.05rem 0 0.08rem;
        display: flex;
        align-items: center;
        p {
          margin-right: 0.08rem;
          i {
            margin: 0 2px;
            font-weight: bold;
          }
        }
      }
      .info {
        height: 0.22rem;
        padding: 0 0.08rem;
        border-radius: 0.04rem;
        background: #fafafa;
        color: #999;
        font-size: 0.12rem;
        line-height: 0.22rem;
        em {
          color: #3b85fe;
        }
        i {
          margin: 0 2px;
          font-weight: bold;
        }
      }
    }
    .star-tip {
      position: absolute;
      background: rgba($color: #0c0f13, $alpha: 0.9);
      width: 0.72rem;
      padding: 0.06rem 0;
      text-align: center;
      border-radius: 0.06rem;
      font-size: 0.12rem;
      color: #fff;
      line-height: 1;
      &:after {
        @include triangle(down, 5px, 4px, rgba($color: #0c0f13, $alpha: 0.9));
        @include center-box(x);
        bottom: -3px;
      }
    }
    .chart-line {
      position: absolute;
      width: 0.76rem;
      height: 0.4rem;
      right: 0.1rem;
      top: 0.16rem;
    }
  }

  .blackTheme {
    .news-list {
      .item {
        &.visited {
          h2 {
            color: #6b7687;
          }
        }
        &:before {
          @include border(top, #1e1f29);
        }
        h2 {
          color: #e4e9fe;
        }
        .tag {
          color: #6b7687;
        }
        .info {
          background: #1e1f29;
          color: #6b7687;
          em {
            color: #3b85fe;
          }
        }
      }
      .star-tip {
        background: rgba($color: #fff, $alpha: 0.9);
        color: #222;
        &:after {
          @include triangle(down, 5px, 4px, rgba($color: #fff, $alpha: 0.9));
        }
      }
    }
  }
</style>
